<template>
  <div class="branch__form">
    <div class="field">
      <vs-input label="Name" v-model="name" size="large"></vs-input>
    </div>
    <div class="field">
      <vs-input label="Prefix" v-model="prefix"   size="large"></vs-input>
    </div>
    <div class="field">
      <vs-textarea label="Description" v-model="description"></vs-textarea>
    </div>

    <div class="branch__save">
      <vs-button icon="save" @click="saveBranch"> Save </vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BranchForm",
  props: ["branch"],
  data() {
    return {
      id: this.branch.id,
      name: this.branch.name,
      prefix: this.branch.prefix,
      description: this.branch.description
    };
  },
  methods: {
    saveBranch: function () {
      let data = {
        id: this.id,
        name: this.name,
        prefix: this.prefix,
        description: this.description
      };
      this.$store
        .dispatch("branches/saveBranchAction", {
          branch: data,
        })
        .then(() => {
          this.$vs.notify({
            title: "Branch saved",
            text: `Branch ${this.name} saved`,
            color: "success",
            position: "top-right"
          });
          this.$store.dispatch("branches/getBranchesAction").then(() => {});
          this.$emit("closePopup");
        });
    }
  }
};
</script>

<style lang="scss">
.branch__date-picker {
  display: inline-block;
  margin: 10px;
  label {
    display: block;
    margin-bottom: 7px;
    color: var(--thead-text-color);
  }
}
.branch__holidays {
  border-top: 1px solid #ccc;
  padding-top: 10px;
  margin-top: 10px;
}
</style>